import React, { useState } from "react";
import { FileAudio } from "lucide-react";
import SearchBar from "../common/SearchBar";

const EpisodeDetails = () => {
  const [searchTerm, setSearchTerm] = useState("");

  return (
    <div className="space-y-6">
      <SearchBar
        value={searchTerm}
        onChange={setSearchTerm}
        placeholder="Search episode details..."
      />
      <div className="bg-white rounded-lg shadow-md p-12 text-center border border-slate-200">
        <FileAudio className="w-16 h-16 mx-auto text-slate-400 mb-4" />
        <h2 className="text-2xl font-bold text-slate-800 mb-2">
          Episode Details
        </h2>
        <p className="text-slate-600 mb-6">
          View and edit detailed episode information
        </p>
        <p className="text-sm text-slate-400">
          Transcripts, show notes, timestamps
        </p>
      </div>
    </div>
  );
};

export default EpisodeDetails;
